import jsonpatch from 'fast-json-patch';

import Entity from '@/core/entity/Entity';
import logger from '@/app/logger';

// TODO: type this — Vuex module context and entity object types
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
type EntityState = Record<string, any>;
/* eslint-enable @typescript-eslint/no-explicit-any */

const EntityStore = {
    namespaced: true,
    state: {} as EntityState,
    getters: {
        getEntityByRef: (state: EntityState) => (ref: string, base: string | Record<string, unknown> | undefined) => {
            if (base == undefined) {
                if (ref === '.') {
                    logger.debug('getEntityByRef: cannot resolve self-pointer with no base');
                    return undefined;
                }
                return state[ref];
            }
            if (typeof base === 'string') {
                base = state[base];
            }
            return ref === '.' ? base : state[ref];
        },
        tokens(state: EntityState) {
            return Object.values(state).filter((entity: Ctx) => entity.token);
        },
    },
    mutations: {
        patch(state: EntityState, delta: Ctx): void {
            const entity = state[delta.id];
            jsonpatch.applyPatch(entity, delta.patch);
        },
        update(state: EntityState, value: Ctx): void {
            const mergeObj = (dest: Ctx, src: Ctx) => {
                for (const prop in src) {
                    // If property exists in destination, if the new value
                    // is an object, merge; otherwise, overwrite.
                    if (Object.prototype.hasOwnProperty.call(dest, prop)) {
                        if (typeof dest[prop] === 'object') {
                            mergeObj(dest[prop], src[prop]);
                        } else {
                            dest[prop] = src[prop];
                        }
                    } else {
                        dest[prop] = src[prop];
                    }
                }
            };

            mergeObj(state[value.id], value);
        },
        add(state: EntityState, entity: Ctx): void {
            state[entity.id] = entity;
        },
        delete(state: EntityState, characterId: string): void {
            delete state[characterId];
        },
    },
    actions: {
        patch({ commit, state }: Ctx, delta: Ctx): void {
            const id = delta.id;
            const patch = delta.patch;
            let entity = state[id];

            if (!entity) {
                entity = {};
                jsonpatch.applyPatch(entity, patch);
                commit('add', entity);
            } else {
                commit('patch', { id, patch });
            }
        },
        update({ commit, state }: Ctx, payload: Ctx): void {
            if (state[payload.id]) {
                payload.value.id = payload.id;
                commit('update', payload.value);
            } else {
                commit('add', payload.value);
            }
        },
        async load({ commit }: Ctx, entities: Ctx): Promise<void> {
            for (const id in entities) {
                commit('add', new Entity(entities[id]));
            }
        },
        remove({ commit }: Ctx, characterId: string): void {
            commit('delete', characterId);
        },
    },
};

export default EntityStore;
